<template>
  <div class="login-container">
    <!-- 背景装饰 -->
    <div class="bg-decoration">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
    </div>

    <div class="login-wrapper">
      <!-- 左侧插画区域 -->
      <div class="login-left">
        <div class="illustration-wrapper">
          <!-- SVG 城市数据可视化插图 -->
          <svg viewBox="0 0 600 500" class="city-illustration">
            <!-- 背景圆环 -->
            <circle cx="300" cy="280" r="180" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="2"/>
            <circle cx="300" cy="280" r="140" fill="none" stroke="rgba(255,255,255,0.15)" stroke-width="2"/>
            
            <!-- 底座平台 -->
            <ellipse cx="300" cy="380" rx="200" ry="40" fill="rgba(255,255,255,0.1)"/>
            <ellipse cx="300" cy="370" rx="180" ry="35" fill="rgba(255,255,255,0.15)"/>
            
            <!-- 中心数据塔 -->
            <rect x="270" y="200" width="60" height="120" rx="5" fill="url(#towerGradient)"/>
            <rect x="280" y="210" width="40" height="20" rx="2" fill="rgba(255,255,255,0.3)"/>
            <rect x="280" y="240" width="40" height="20" rx="2" fill="rgba(255,255,255,0.3)"/>
            <rect x="280" y="270" width="40" height="20" rx="2" fill="rgba(255,255,255,0.3)"/>
            
            <!-- 顶部发光点 -->
            <circle cx="300" cy="190" r="8" fill="#4fc3f7">
              <animate attributeName="opacity" values="1;0.5;1" dur="2s" repeatCount="indefinite"/>
            </circle>
            
            <!-- 左侧建筑 -->
            <rect x="180" y="250" width="50" height="100" rx="4" fill="url(#buildingGradient1)"/>
            <rect x="190" y="260" width="30" height="15" rx="2" fill="rgba(255,255,255,0.25)"/>
            <rect x="190" y="285" width="30" height="15" rx="2" fill="rgba(255,255,255,0.25)"/>
            <rect x="190" y="310" width="30" height="15" rx="2" fill="rgba(255,255,255,0.25)"/>
            
            <!-- 右侧建筑 -->
            <rect x="370" y="230" width="60" height="120" rx="4" fill="url(#buildingGradient2)"/>
            <rect x="380" y="245" width="40" height="18" rx="2" fill="rgba(255,255,255,0.25)"/>
            <rect x="380" y="275" width="40" height="18" rx="2" fill="rgba(255,255,255,0.25)"/>
            <rect x="380" y="305" width="40" height="18" rx="2" fill="rgba(255,255,255,0.25)"/>
            
            <!-- 数据图表元素 -->
            <!-- 柱状图 -->
            <rect x="150" y="320" width="20" height="60" rx="2" fill="#64b5f6" opacity="0.8"/>
            <rect x="175" y="300" width="20" height="80" rx="2" fill="#42a5f5" opacity="0.8"/>
            <rect x="200" y="340" width="20" height="40" rx="2" fill="#90caf9" opacity="0.8"/>
            
            <!-- 饼图 -->
            <circle cx="450" cy="320" r="35" fill="none" stroke="#64b5f6" stroke-width="8" stroke-dasharray="55 165"/>
            <circle cx="450" cy="320" r="35" fill="none" stroke="#42a5f5" stroke-width="8" stroke-dasharray="45 175" stroke-dashoffset="-55"/>
            <circle cx="450" cy="320" r="35" fill="none" stroke="#90caf9" stroke-width="8" stroke-dasharray="65 155" stroke-dashoffset="-100"/>
            
            <!-- 连接线 -->
            <line x1="300" y1="200" x2="205" y2="250" stroke="rgba(255,255,255,0.3)" stroke-width="2" stroke-dasharray="5,5">
              <animate attributeName="stroke-dashoffset" from="0" to="10" dur="1s" repeatCount="indefinite"/>
            </line>
            <line x1="300" y1="200" x2="400" y2="230" stroke="rgba(255,255,255,0.3)" stroke-width="2" stroke-dasharray="5,5">
              <animate attributeName="stroke-dashoffset" from="0" to="10" dur="1s" repeatCount="indefinite"/>
            </line>
            <line x1="300" y1="200" x2="165" y2="320" stroke="rgba(255,255,255,0.2)" stroke-width="2" stroke-dasharray="5,5"/>
            <line x1="300" y1="200" x2="450" y2="285" stroke="rgba(255,255,255,0.2)" stroke-width="2" stroke-dasharray="5,5"/>
            
            <!-- 悬浮数据点 -->
            <circle cx="150" cy="280" r="6" fill="#4fc3f7">
              <animate attributeName="cy" values="280;270;280" dur="3s" repeatCount="indefinite"/>
            </circle>
            <circle cx="480" cy="260" r="5" fill="#81d4fa">
              <animate attributeName="cy" values="260;250;260" dur="2.5s" repeatCount="indefinite"/>
            </circle>
            <circle cx="120" cy="350" r="4" fill="#b3e5fc">
              <animate attributeName="cy" values="350;340;350" dur="2s" repeatCount="indefinite"/>
            </circle>
            
            <!-- 数据流动效果 -->
            <path d="M 100 400 Q 300 350 500 400" fill="none" stroke="rgba(79,195,247,0.3)" stroke-width="3">
              <animate attributeName="d" values="M 100 400 Q 300 350 500 400;M 100 400 Q 300 380 500 400;M 100 400 Q 300 350 500 400" dur="4s" repeatCount="indefinite"/>
            </path>
            
            <!-- 渐变定义 -->
            <defs>
              <linearGradient id="towerGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" style="stop-color:#4fc3f7;stop-opacity:0.9" />
                <stop offset="100%" style="stop-color:#0288d1;stop-opacity:0.9" />
              </linearGradient>
              <linearGradient id="buildingGradient1" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" style="stop-color:#81d4fa;stop-opacity:0.8" />
                <stop offset="100%" style="stop-color:#29b6f6;stop-opacity:0.8" />
              </linearGradient>
              <linearGradient id="buildingGradient2" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" style="stop-color:#4fc3f7;stop-opacity:0.8" />
                <stop offset="100%" style="stop-color:#039be5;stop-opacity:0.8" />
              </linearGradient>
            </defs>
          </svg>
          
          <div class="slogan">
            <h2>智瞰·项目雷达</h2>
            <p>企业级商业情报智能分析平台</p>
          </div>
        </div>
      </div>

      <!-- 右侧登录表单 -->
      <div class="login-right">
        <div class="login-box">
          <div class="login-header">
            <h3 class="system-title">欢迎登录</h3>
            <p class="system-subtitle">智瞰·项目雷达 | 企业级商业情报智能分析平台</p>
          </div>

          <!-- 登录方式切换 -->
          <div class="login-tabs">
            <div 
              :class="['tab-item', { active: loginType === 'phone' }]"
              @click="loginType = 'phone'"
            >
              <i class="el-icon-mobile-phone"></i>
              手机登录
            </div>
            <div 
              :class="['tab-item', { active: loginType === 'account' }]"
              @click="loginType = 'account'"
            >
              <i class="el-icon-user"></i>
              账号登录
            </div>
          </div>

          <!-- 手机验证码登录 -->
          <el-form 
            v-if="loginType === 'phone'"
            ref="phoneForm"
            :model="phoneForm"
            :rules="phoneRules"
            class="login-form"
          >
            <el-form-item prop="phone">
              <el-input
                v-model="phoneForm.phone"
                prefix-icon="el-icon-mobile-phone"
                placeholder="请输入手机号码"
                maxlength="11"
                clearable
              />
            </el-form-item>

            <el-form-item prop="smsCode" class="sms-item">
              <div class="sms-wrapper">
                <el-input
                  v-model="phoneForm.smsCode"
                  prefix-icon="el-icon-message"
                  placeholder="请输入验证码"
                  maxlength="6"
                  @keyup.enter.native="handleLogin"
                />
                <el-button
                  :disabled="smsCountdown > 0"
                  class="sms-btn"
                  @click="handleSendSms"
                >
                  {{ smsCountdown > 0 ? `${smsCountdown}s后重发` : '获取验证码' }}
                </el-button>
              </div>
            </el-form-item>

            <el-button
              type="primary"
              :loading="loading"
              class="login-btn"
              @click="handleLogin"
            >
              登 录
            </el-button>
          </el-form>

<!-- 账号密码登录 -->
          <el-form 
            v-else
            ref="accountForm"
            :model="accountForm"
            :rules="accountRules"
            class="login-form"
          >
            <el-form-item prop="username">
              <el-input
                v-model="accountForm.username"
                prefix-icon="el-icon-user"
                placeholder="请输入用户名/账号"
                clearable
              />
            </el-form-item>
            
            <el-form-item prop="password">
              <el-input
                v-model="accountForm.password"
                prefix-icon="el-icon-lock"
                :type="passwordVisible ? 'text' : 'password'"
                placeholder="请输入密码"
                clearable
              >
                <i 
                  slot="suffix"
                  :class="['el-input__icon', passwordVisible ? 'el-icon-view' : 'el-icon-hide']"
                  @click="passwordVisible = !passwordVisible"
                ></i>
              </el-input>
            </el-form-item>

            <el-button
              type="primary"
              :loading="loading"
              class="login-btn"
              @click="handleLogin"
            >
              登 录
            </el-button>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 页脚备案信息 -->
    <div class="login-footer">
      <div class="footer-content">
        <p class="copyright"> 深圳市智瞰商讯科技有限公司 </p>
        <p class="beian">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
            粤ICP备2026054924号-1
          </a>
          <!-- <span class="divider">|</span>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
            粤公网安备XXXXXXXXXXXXXX号
          </a> -->
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { clearSignCache } from '@/router'
export default {
  name: 'Login',
  data() {
    
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^((\+|00)86)?1[3-9]\d{9}$/;
      if (!value) {
        callback(new Error('请输入手机号码'))
      } else if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }

    return {
      // 登录类型：account-账号登录, phone-手机登录
      loginType: 'phone',
      curWebsite: this.$api.getWebsiteType(),
      // 账号登录表单
      accountForm: {
        username: '',
        password: '',
        captcha: ''
      },
      
      // 手机登录表单
      phoneForm: {
        phone: '',
        smsCode: ''
      },
      
      // 表单验证规则
      accountRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6位', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 4, message: '验证码为4位', trigger: 'blur' }
        ]
      },
      
      phoneRules: {
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 6, message: '验证码为6位', trigger: 'blur' }
        ]
      },
      
      // 状态
      loading: false,
      passwordVisible: false,
      smsCountdown: 0,
      smsTimer: null,

    }
  },
  
  mounted() {
    // 页面标题设置
    document.title = '智瞰平台 | 企业级商业情报智能分析平台';
  },
  
  beforeDestroy() {
    // 清理定时器
    if (this.smsTimer) {
      clearInterval(this.smsTimer)
    }
  },
  
  methods: {
    //与后台返回的域名对比，校验用户登录版本
    checkWebsite(userData) { 
      
      const systemDomain = userData.domain;
      // console.log('当前系统域名', this.curWebsite, '用户域名', userData,systemDomain.indexOf(this.curWebsite.url));
      if (systemDomain.indexOf(this.curWebsite.url) !== -1) {
        return true;
      } else {
        this.$message({
          message: '当前账号登录版本与系统版本不一致，请联系客服！',
          type: 'error',
          duration: 5000
        });
        return false;
      }
    },

    passwordLogin(loginUserdata) { 
      var that = this;
      var loginurl = this.$api.user.user.login();
      console.log('登陆参数',loginurl,loginUserdata);
      $.ajax({
        type: "post",
        url: loginurl,
        data: loginUserdata,
        success: function (res) {
          var resdata = res;
          console.log('登陆返回', resdata);
          if (resdata.success) {
            that.loading = false;
            var logindata = resdata.data;
            if(that.curWebsite.type == 3 && process.env.NODE_ENV !== 'development') { //3 vip版功能最全
            let isWebsite = that.checkWebsite(logindata);
              if (!isWebsite) {
                return;
            }
            }
            
            that.loginsuccess(logindata);
            localStorage.setItem('token', logindata.token);
            sessionStorage.setItem('token', logindata.token);
            that.routerself('/dashboard');
          } else {
            that.loading = false;
            that.errortext = resdata.msg;
            that.$message.error(that.errortext);
          }
        }
      })
    },
    loginsuccess(datasm) {
      console.log('loginsucces 设置消息提示');
      let datasm1 = datasm;
      localStorage.setItem('loginType', JSON.stringify({ loginTypePwd: this.loginType })); 
      // ✅ 关键：切换账号时清除旧账号的签约缓存
      clearSignCache();
      if (typeof datasm === 'object') {
        datasm1 = JSON.stringify(datasm);
      }
      localStorage.setItem('userData', datasm1);
      sessionStorage.setItem('userData', datasm1);
    },
    // 发送短信验证码
    handleSendSms() {
      this.$refs.phoneForm.validateField('phone', (errorMessage) => {
        if (!errorMessage) {
          this.checkSmsLogin().then(res => { 
              if (res) {
                 // 发送短信
                this.sendCode();
              } else {
                
                this.$message.error('您尚未开通短信登录服务，请联系客服');
              }
            })
          
        }
      })
    },
    sendCode() {
				let _this = this;
				let ajaxUrl = this.$api.common.sms.send() + "?mobile=" + this.phoneForm.phone + '&type=2';
				this.$axios.get(ajaxUrl).then(function (res) {
					// console.log('发送验证码',res); 
					if (res.success) {
						_this.$message.success(res.msg);
						if (res.code == 0) {
							_this.smsCountdown = 60
                _this.smsTimer = setInterval(() => {
                  _this.smsCountdown--
                  if (_this.smsCountdown <= 0) {
                    clearInterval(_this.smsTimer)
                  }
                }, 1000)
						}
					} else {
						let errMsg = res.msg;
						if (res.code == 1022) {
							errMsg = '短信日下发条数超过设定的上限';
						} else if (res.code == 1023) {
							errMsg = '手机号30秒内下发短信条数超过设定的上限';
						} else if (res.code == 1024) {
							errMsg = '手机号1小时内下发短信条数超过设定的上限';
						} else if (res.code == 1025) {
							errMsg = '手机号日下发短信条数超过设定的上限';
						}
						_this.$message.error(errMsg);
					}

				}).catch(function (error) {
					// 处理错误情况
					console.log(error);
				})


	},
    // 登录处理
    handleLogin() {
      const formName = this.loginType === 'account' ? 'accountForm' : 'phoneForm'
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.loginType === 'account') {
            this.passwordLogin({username: this.accountForm.username, password: this.accountForm.password, client: 1});
          } else {
                this.passwordLogin({username: this.phoneForm.phone, code: this.phoneForm.smsCode, client: 1});
          }
        }
      })
    },
    //调用后台接口检测手机号是否设置为短信登陆
    checkSmsLogin() {
      return new Promise((resolve, reject) => {
        let _this = this;
        console.log('检测是否设置短信登陆手机号', this.$api.common.sms.isSmsLogin());
        let ajaxUrl = this.$api.common.sms.isSmsLogin() + "?mobile=" + this.phoneForm.phone;
        this.$axios.get(ajaxUrl).then(function (res) {
          console.log('检测是否设置短信登陆', res);
          if (res.success) {
            // _this.set_isSmsLogin(true);
            _this.errortext = '';
            resolve(true);
          } else {
            // _this.set_isSmsLogin(false);
            _this.errortext = '您尚未开通短信登录服务，请联系客服';
            resolve(false);
          }
        }).catch(function (error) {
          resolve(false);
          console.log(error);
        })
      })
    },
  }
  }
</script>

<style lang="less" scoped>
.login-container {
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(135deg, #1e3a5f 0%, #2c5282 50%, #1a365d 100%);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 60px; // 为页脚留出空间
  
  // 背景装饰
  .bg-decoration {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    
    .circle {
      position: absolute;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.03);
      
      &.circle-1 {
        width: 600px;
        height: 600px;
        top: -200px;
        right: -100px;
      }
      
      &.circle-2 {
        width: 400px;
        height: 400px;
        bottom: -100px;
        left: -100px;
      }
      
      &.circle-3 {
        width: 300px;
        height: 300px;
        top: 50%;
        left: 30%;
        background: rgba(79, 195, 247, 0.05);
      }
    }
  }
}

.login-wrapper {
  display: flex;
  width: 1000px;
  height: 560px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  position: relative;
  z-index: 1;
  margin-bottom: 20px;
}

// 左侧插画区域
.login-left {
  flex: 1;
  background: linear-gradient(180deg, #2c5282 0%, #1e3a5f 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    opacity: 0.5;
  }
  
  .illustration-wrapper {
    text-align: center;
    padding: 40px;
    position: relative;
    z-index: 1;
    
    .city-illustration {
      width: 400px;
      height: 350px;
      filter: drop-shadow(0 10px 30px rgba(0, 0, 0, 0.2));
    }
    
    .slogan {
      margin-top: 30px;
      color: #fff;
      
      h2 {
        font-size: 32px;
        font-weight: 600;
        margin-bottom: 10px;
        letter-spacing: 4px;
      }
      
      p {
        font-size: 16px;
        opacity: 0.8;
        letter-spacing: 2px;
      }
    }
  }
}

// 右侧登录区域
.login-right {
  width: 420px;
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 60px 40px 40px;
  position: relative;
  
  .login-box {
    flex: 1;
  }
  
  .login-header {
    text-align: center;
    margin-bottom: 30px;
    
    .system-title {
      font-size: 24px;
      color: #1a365d;
      font-weight: 600;
      margin-bottom: 8px;
    }
    
    .system-subtitle {
      font-size: 13px;
      color: #718096;
    }
  }
}

// 登录标签切换
.login-tabs {
  display: flex;
  margin-bottom: 25px;
  border-bottom: 2px solid #e2e8f0;
  
  .tab-item {
    flex: 1;
    text-align: center;
    padding: 12px 0;
    cursor: pointer;
    color: #718096;
    font-size: 15px;
    transition: all 0.3s;
    position: relative;
    
    i {
      margin-right: 5px;
    }
    
    &:hover {
      color: #2c5282;
    }
    
    &.active {
      color: #2c5282;
      font-weight: 500;
      
      &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 20%;
        right: 20%;
        height: 2px;
        background: #2c5282;
        border-radius: 2px;
      }
    }
  }
}

// 登录表单
.login-form {
  .el-form-item {
    margin-bottom: 20px;
  }
  
  ::v-deep .el-input__inner {
    height: 44px;
    line-height: 44px;
    border-radius: 6px;
    border-color: #e2e8f0;
    
    &:focus {
      border-color: #2c5282;
    }
  }
  
  ::v-deep .el-input__prefix {
    left: 12px;
    
    .el-input__icon {
      line-height: 44px;
      color: #a0aec0;
    }
  }
  
  ::v-deep .el-input__suffix {
    right: 12px;
    
    .el-input__icon {
      line-height: 44px;
      color: #a0aec0;
      cursor: pointer;
      
      &:hover {
        color: #2c5282;
      }
    }
  }
}

// 短信验证码样式
.sms-item {
  .sms-wrapper {
    display: flex;
    gap: 12px;
    
    .el-input {
      flex: 1;
    }
    
    .sms-btn {
      width: 120px;
      height: 44px;
      padding: 0;
      border-radius: 6px;
      border-color: #2c5282;
      color: #2c5282;
      
      &:hover:not(:disabled) {
        background: rgba(44, 82, 130, 0.1);
      }
      
      &:disabled {
        border-color: #cbd5e0;
        color: #a0aec0;
      }
    }
  }
}

// 登录按钮
.login-btn {
  width: 100%;
  height: 46px;
  font-size: 16px;
  border-radius: 6px;
  background: linear-gradient(135deg, #2c5282 0%, #1a365d 100%);
  border: none;
  box-shadow: 0 4px 12px rgba(44, 82, 130, 0.3);
  
  &:hover {
    background: linear-gradient(135deg, #1a365d 0%, #2c5282 100%);
    box-shadow: 0 6px 16px rgba(44, 82, 130, 0.4);
  }
  
  &:disabled {
    opacity: 0.6;
  }
}

// 页脚备案信息
.login-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background: rgba(26, 54, 93, 0.85);
  backdrop-filter: blur(4px);
  padding: 12px 0;
  
  .footer-content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
    
    .copyright {
      color: rgba(255, 255, 255, 0.6);
      font-size: 12px;
      margin: 0;
    }
    
    .beian {
      display: flex;
      align-items: center;
      gap: 12px;
      margin: 0;
      
      a {
        color: rgba(255, 255, 255, 0.6);
        font-size: 12px;
        text-decoration: none;
        transition: color 0.3s;
        
        &:hover {
          color: #4fc3f7;
          text-decoration: underline;
        }
      }
      
      .divider {
        color: rgba(255, 255, 255, 0.3);
        font-size: 12px;
      }
    }
  }
}

// 响应式适配
@media screen and (max-width: 1024px) {
  .login-wrapper {
    width: 90%;
    max-width: 900px;
  }
  
  .login-left {
    .illustration-wrapper {
      .city-illustration {
        width: 300px;
        height: 260px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .login-wrapper {
    flex-direction: column;
    height: auto;
    max-height: none;
    margin-bottom: 80px;
  }
  
  .login-left {
    display: none;
  }
  
  .login-right {
    width: 100%;
    padding: 30px;
  }
  
  .login-footer {
    padding: 10px 0;
    
    .footer-content {
      flex-direction: column;
      gap: 6px;
    }
  }
}
::v-deep .el-input--prefix .el-input__inner {
    padding-left: 45px;
}
</style>